import THREE from '@/lib/three-extra'

export default {
  data () {
    return {
      shouldRender: true,
      clock: new THREE.Clock(),
      container: undefined,
      renderer: undefined,
      element: undefined,
      scene: undefined,
      camera: undefined,
      rafID: 0,
      width: 0,
      height: 0
    }
  },
  computed: {
    pixelRatio () {
      if ('devicePixelRatio' in window) {
        if (window.devicePixelRatio > 1) {
          return window.devicePixelRatio
        }
      }
      return 1
    }
  },
  methods: {
    init ( el, fov = 62.5, near = 0.5, far = 1000 ) {
      this.container = document.getElementById( el )
      this.renderer = new THREE.WebGLRenderer( { antialias: true } )
      this.renderer.setPixelRatio(this.pixelRatio)
      this.renderer.context.canvas.addEventListener( 'webglcontextlost', this.onGLContextLost )
      this.element = this.renderer.domElement
      this.container.appendChild(this.element)

      this.scene = new THREE.Scene()
      this.camera = new THREE.PerspectiveCamera(fov, this.container.offsetWidth / this.container.offsetHeight, near, far)
      this.camera.position.set(0, 5, 25)
      this.scene.add(this.camera)
    },
    onGLContextLost ( e ) {
      e.preventDefault()
      cancelAnimationFrame( this.rafID )
      this.$store.dispatch( 'setDemoCapable', false )
      this.$router.push( '/report' )
    },
    onResize () {
      this.width = this.container.offsetWidth
      this.height = this.container.offsetHeight

      if (this.camera) {
        this.camera.aspect = this.width / this.height
        this.camera.updateProjectionMatrix()
      }

      this.renderer.setSize(this.width, this.height)
    },
    update ( dt ) {
      this.camera.updateProjectionMatrix()
    },
    render ( dt ) {
      this.renderer.render(this.scene, this.camera)
    },
    animate ( t ) {
      this.rafID = requestAnimationFrame(() => {
        this.animate()
      })

      if (this.shouldRender) {
        this.update( this.clock.getDelta() )
        this.render( this.clock.getDelta() )
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/GLViewMixin.js